export default function Login() {
  return (
    <div className="container">
      <h1>Log In</h1>
      <form method="post" action="/api/auth/username">
        <label>Name:
          <input type="text" name="username" placeholder="Name" autoFocus />
        </label>
        <input type="submit" />
      </form>
    </div>
  )
}
